import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Field } from "formik";
import * as _ from "lodash";
import { customInputComponent } from "../../forms/customInputBronson";
import * as rk from "../../localization/resourceKeys";
import { AccessMyInfoIcon } from "../Icons/icons";
import { pinFormValidations } from "../../utils/validations";
import BannerNotification from "../../banner/bannerNotification";
import PropTypes from "prop-types";

import "./createPinForm.css";

class PinForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      actualPin: "",
      maskedPin: "",
      actualRePin: "",
      maskedRePin: "",
    };

    this.handleMaskedFieldChange = this.handleMaskedFieldChange.bind(this);
  }

  componentDidMount() {
    pinFormValidations();
  }

  handleMaskedFieldChange(event, setFieldValue, pinField) {
    const _this = this;
    const prevValue =
      pinField === "pinNumber" ? this.state.maskedPin : this.state.maskedRePin;
    const newValue = event.target.value;
    let actual =
      pinField === "pinNumber" ? this.state.actualPin : this.state.actualRePin;

    // typing forward
    if (newValue.length > prevValue.length) {
      let newChar = newValue.split("").pop();
      actual = `${actual}${newChar}`;
    } else {
      // backspacing / deleting
      const charsRemovedCount = prevValue.length - newValue.length;
      actual = actual.substr(0, actual.length - charsRemovedCount);
    }

    let masked = actual.replace(/\d/g, "*");
    if (pinField === "pinNumber") {
      this.setState(
        {
          actualPin: actual,
          maskedPin: masked,
        },
        () => {
          setFieldValue("pinNumber", this.state.actualPin);
        }
      );
    } else {
      this.setState(
        {
          actualRePin: actual,
          maskedRePin: masked,
        },
        () => {
          setFieldValue("reEnterPinNumber", this.state.actualRePin);
        }
      );
    }

    if (actual.length === 4) {
      setTimeout(() => {
        masked = actual.replace(/\d/g, "*");
        if (pinField === "pinNumber") {
          _this.setState(
            {
              actualPin: actual,
              maskedPin: masked,
            },
            () => {
              setFieldValue("pinNumber", _this.state.actualPin);
            }
          );
        } else {
          _this.setState(
            {
              actualRePin: actual,
              maskedRePin: masked,
            },
            () => {
              setFieldValue("reEnterPinNumber", _this.state.actualRePin);
            }
          );
        }
      }, 1000);
    }
  }

  render() {
    const { t } = this.props;
    const { handleSubmit, canSubmit, setFieldValue } = this.props;

    return (
      <div
        onSubmit={handleSubmit}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            handleSubmit();
          }
        }}
      >
        <section className="o-content-section">
          <div className="o-page-wrap">
            <AccessMyInfoIcon />
          </div>
        </section>

        {!_.isEmpty(this.props.networkError) && (
          <BannerNotification notificationStyle="error">
            {t(rk.ERROR_API_FAIL)}
          </BannerNotification>
        )}

        <section className="u-text-center">
          <div className="o-layout__item u-1 u-1/1@s u-p-none@s u-mb-large pin-form-questionnaire">
            {t(rk.CREATE_PIN_FORM.TITLE)}
          </div>
        </section>

        <section>
          <div className="o-layout u-1 u-1/1@xs u-1/1@s u-block-center">
            <div className="pin-input-group">
              <Field
                styleNote={t(rk.CREATE_PIN_FORM.PIN_NUMBER)?true:""}
                name="pinNumber"
                className="o-layout__item u-p-none"
                data-testid="pinNumber"
                placeHolder={t(rk.CREATE_PIN_FORM.PIN_NUMBER)}
                altPlaceholder={t(rk.CREATE_PIN_FORM.PIN_NUMBER).toUpperCase()}
                type="text"
                id="pinNumber"
                component={customInputComponent}
                error={this.props.errors.pinNumber}
                helpContent={
                  this.props.errors.pinNumber && this.props.touched.pinNumber
                    ? this.props.errors.pinNumber
                    : ""
                }
                onChange={(e) =>
                  this.handleMaskedFieldChange(e, setFieldValue, "pinNumber")
                }
                value={this.state.maskedPin}
              />

              <label htmlFor="pinNumber" className="pin-note">
                {t(rk.CREATE_PIN_FORM.NOTE)}
              </label>
            </div>


          </div>
        </section>

        <section className="u-text-center">
          <div className="o-layout u-1 u-1/1@xs u-1/1@s u-block-center">
            <Field
              name="reEnterPinNumber"
              className="o-layout__item u-p-none"
              placeHolder={t(rk.CREATE_PIN_FORM.REENTER_PIN_NUMBER)}
              altPlaceholder={t(
                rk.CREATE_PIN_FORM.REENTER_PIN_NUMBER
              ).toUpperCase()}
              type="text"
              id="reEnterPinNumber"
              component={customInputComponent}
              error={this.props.errors.reEnterPinNumber}
              helpContent={
                this.props.errors.reEnterPinNumber &&
                  this.props.touched.reEnterPinNumber
                  ? this.props.errors.reEnterPinNumber
                  : ""
              }
              onChange={(e) =>
                this.handleMaskedFieldChange(
                  e,
                  setFieldValue,
                  "reEnterPinNumber"
                )
              }
              value={this.state.maskedRePin}
              data-testid="reEnterPinNumber"
            />
          </div>
        </section>

        <section className="u-text-center">
          <div className="o-layout__item u-3/6 u-1/1@s">
            <button
              className="c-btn"
              onClick={handleSubmit}
              disabled={!canSubmit}
              data-testid="submit-button"
            >
              <span className="c-btn__text">{t(rk.BUTTON.SUBMIT)}</span>
            </button>
          </div>
        </section>
      </div>
    );
  }
}

PinForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  canSubmit: PropTypes.bool.isRequired,
  errors: PropTypes.shape({
    pinNumber: PropTypes.string,
    reEnterPinNumber: PropTypes.string,
  }),
  touched: PropTypes.shape({
    pinNumber: PropTypes.bool,
    reEnterPinNumber: PropTypes.bool,
  }),
  networkError: PropTypes.string,
  setFieldValue: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(PinForm);
